<template>
	<div class="coantiner" >
    <div v-if="steps.length>0" style="background-color: white">
    <div class="title">
      <p>{{expressCompany}}：{{expressNumber}}</p>
    </div>
      <div id="time-line" style="padding: 0.2rem 0.2rem">
        <div class="item"  v-for="item in steps" :key="item.index">
          <div class="item-index">{{item.time}}</div>
          <div class="item-content">{{item.status}}</div>
        </div>
      </div>
    </div>
    <noth-modal v-else></noth-modal>
  </div>
</template>

<script>
import NothModal from '../Modal/NothModal'
export default {
  name: 'packLogin',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    NothModal
  },
  data () {
    return {
      expressNumber: '',
      expressCompany: '',
      steps: []
    }
  },
  activated () {
    this.expressNumber = this.$route.query.expressNumber
    this.expressCompany = this.$route.query.expressCompany
    this.logisticsInfo()
  },
  methods: {
    logisticsInfo () {
      const par = {
        num: this.$route.query.expressNumber
      }
      this.http.APIASK(this.ports.logisticsInfo, 'get', par).then(res => {
        const result = res.list.map(function (item) {
          // tslint:disable-next-line:radix
          return { name: item.status, text: item.time }
        })
        console.log(result)
        this.steps = res.list
      })
    }
  }
}
</script>

<style lang="less">
.coantiner{
  .title{
    height: 1rem;
    display: flex;
    align-items: center;
    font-size: 0.32rem;
    border-bottom: 1px solid #e2e2e2;
    padding-left: 0.3rem;
  }
  .item {

    margin-left: 30px; /*用左边margin显示时间线*/
    width: calc(100% - 30px); /*因为左边部分用于显示时间线，所以右边部分减去30px*/
    height: auto; /*高度由内容决定*/
    position: relative;
    margin-bottom: 10px;
    cursor: pointer;
  }
  .item::before {
    content: "";
    width: 11px;
    height: 11px;
    border-radius: 100%;
    background-color: #91c2fc;
    position: absolute;
    left: -15px;
  }
  .item::after {
    content: "";
    width: 3px;
    height: calc(100% + 10px); /*加上10px是item底部的margin*/
    background-color: #91c2fc;
    position: absolute;
    top: 0;
    left: -11px;
  }
  .item-index {
    padding: 0.1rem 0;
    line-height: 12px;
    font-size: 0.32rem;
    text-align: left;
    position: relative;
    color: #656565;
    padding-left: 0.1rem;
  }
  .item-content {
    padding-top: 0.4rem;
    width: 100%;
    font-size: 0.3rem;
    text-align: left;
    padding-left: 0.1rem;
    height: auto; /*由内容决定*/
    position: relative;
    white-space: pre-wrap; /*保留空白符序列，但是正常地进行换行*/
    word-wrap: break-word; /*在长单词或 URL 地址内部进行换行*/
  }
  .item:hover::before {
    transform: scale3d(1.2, 1.2, 1);
    background-color: #569ffb;
  }

  .item:hover::after {
    transform: scale3d(1.1, 1, 1);
    background-color: #569ffb;
  }

  .item:hover .item-index{
    transform: scale3d(1.01, 1.01, 1);
    color: #343434;
  }
}
</style>

